import React, { useState, useCallback, memo, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useEquipmentLevel } from './useEquipmentLevel';
import { useCharts } from './useCharts';
import { useLoadingStore } from '../store/loadingStore';

export const EquipmentLevel: React.FC<{
  period: string;
  time: string;
}> = memo(({ period, time }) => {
  const { allResults, totalResults, leakerResults } = useEquipmentLevel({
    period,
    time,
  });

  const {
    ChartCollection2,
    ChartCollection3,
    ChartCollection4,
    ChartCollection5,
    ChartCollection7,
  } = useCharts();

  const setLoading = useLoadingStore((state) => state.setLoading);

  const [activeTab] = useState(0);

  useEffect(() => {
    const isDataReady = () => {
      switch (activeTab) {
        case 0:
          return allResults.length > 0;
        default:
          return false;
      }
    };

    if (isDataReady()) {
      setLoading(false, 100);
    }
  }, [activeTab, allResults, leakerResults, totalResults, setLoading]);

  const renderActiveTabContent = useCallback(() => {
    switch (activeTab) {
      case 0:
        return (
          <>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              }}
              width={'100%'}
              padding={1}
            >
              <Grid
                item
                width={'48%'}
                paddingRight={'2%'}
                className={'allcharts withDivider'}
              >
                <ChartCollection7 allResults={allResults} compact={true} />
              </Grid>
              <Grid
                item
                width={'48%'}
                paddingLeft={'2%'}
                className={'allcharts doubleSize'}
              >
                <ChartCollection3
                  allResults={leakerResults}
                  tabType={'equip'}
                  compact={true}
                />
                <ChartCollection2
                  allResults={leakerResults}
                  tabType={'equip'}
                  compact={true}
                />
                <ChartCollection4 allResults={totalResults} compact={true} />
                <ChartCollection5
                  allResults={allResults}
                  title={'Cumulative Fraction of Emitting Equipment'}
                  compact={true}
                />
              </Grid>
            </Grid>
          </>
        );
      default:
        return null;
    }
  }, [activeTab, allResults, leakerResults, totalResults]);

  return (
    <div className="tabs" style={{ marginTop: '125px', padding: '0 10px' }}>
      <div className="tab-content">{renderActiveTabContent()}</div>
    </div>
  );
});
